import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";

import "simplebar";
import "simplebar/dist/simplebar.css";

import { initSlideshows } from "./lib/slideshows.js";
import { adjustUnderline } from "./lib/adjustUnderline.js";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();

	initSlideshows();

	// if we have a banner heading on the page.
	if (document.querySelector(".banner .txt-col h1")) {
		// adjustUnderline();
		setTimeout(() => {
			adjustUnderline();
		}, 1);
		window.addEventListener("resize", adjustUnderline);
	}

	tailwind.config = {
		corePlugins: {
			preflight: false,
		},
		theme: {
			extend: {
				colors: {
					primary: "var(--color-primary)",
					secondary: "var(--color-secondary)",
					tertiary: "var(--color-tertiary)",
					quaternary: "var(--color-quaternary)",
					quinary: "var(--color-quinary)",
					warning: "var(--color-warning)",
					success: "var(--color-success)",
					orange: "var(--color-orange)",
					lightOrange: "var(--color-light-orange)",
					purple: "var(--color-purple)",
					lightPurple: "var(--color-light-purple)",
					lighterPurple: "var(--color-lighter-purple)",
					mutedPurple: "var(--color-muted-purple)",
					darkMutedPurple: "var(--color-dark-muted-purple)",
					gray: "var(--color-gray)",
					darkGray: "var(--color-dark-gray)",
					lightGray: "var(--color-light-gray)",

					// gray: "var(--color-gray)",
					// white: "var(--color-white)",
				},
			},
		},
	};
	if (document.querySelector(".meetup-team-tabs")) {
		setupMeetupTeamTabs();
	}

	if (document.querySelector(".blurb-text-accordion-expander")) {
		// get all of them
		const dropdowns = document.querySelectorAll(".blurb-text-accordion-expander");

		dropdowns.forEach((dropdown) => {
			dropdown.addEventListener("click", (e) => {
				e.preventDefault();
				// toggle the button active class
				dropdown.classList.toggle("active");

				// get the content
				const content = dropdown.nextElementSibling;
				// toggle the content
				content.classList.toggle("active");
			});
		});
	}
});

const setupMeetupTeamTabs = () => {
	const tabs = document.querySelectorAll(".meetup-team-tabs .tab");

	const tabContents = document.querySelectorAll(".meetup-team-tab-contents .tab-content");

	tabs.forEach((tab, i) => {
		tab.addEventListener("click", (e) => {
			e.preventDefault();
			tabs.forEach((tab) => tab.classList.remove("active"));
			tab.classList.add("active");
			// get tab data target
			let tabTarget = tab.getAttribute("data-target");

			let targettedTabContent = document.querySelector("#" + tabTarget);

			tabContents.forEach((tabContent) => tabContent.classList.remove("active"));
			targettedTabContent.classList.add("active");
		});
	});
};
